import { Card, FlexBox, FluidImage, Typography } from '@vp/swan';
import React, { ReactNode } from 'react';

import './OrderCard.styles.scss';
import { formatDateWithOrdinal } from '../../../utils/miaw/common';

export interface IOrderCardProps {
  onClick?: (selectedOrderId: string) => void;
  orderId: string;
  orderNumber: string;
  orderDate: number;
  displayPrice: string;
  orderItems: {
    itemId: string;
    imageUrl: string;
  }[];
  sender: 'chatbot' | 'user';
}
const OrderCard: React.FC<IOrderCardProps> = ({
  orderDate,
  orderId,
  orderItems,
  //  orderNumber,
  displayPrice,
  onClick,
  sender,
}) => {
  /** Function to get the number of products in the order, if order items > 2 show the count of items */
  const getFormattedItems = () => {
    let updatedList: ({ type?: 'lineItem'; itemId: string; imageUrl: string } | { type: 'reactNode'; element: ReactNode })[] = [];
    if (orderItems.length > 2) {
      updatedList = orderItems.slice(0, 1);
      updatedList.push({
        type: 'reactNode',
        element: <Typography fontSkin="body-standard-bold" className="order-items-more">{`+${orderItems.length - 1}`}</Typography>,
      });
    } else {
      updatedList = orderItems;
    }
    return updatedList;
  };

  const handleOrderClick = () => {
    if (sender === 'chatbot' && onClick) {
      onClick(orderId);
    }
  };
  return (
    <>
      <Card
        onClick={handleOrderClick}
        bordered
        padding={6}
        compactMode
        className="order-card"
        skin={sender === 'chatbot' ? 'link' : undefined}
        marginY="between-actions"
        style={{ cursor: sender === 'chatbot' ? 'pointer' : 'default' }}
      >
        <FlexBox justifyContent="space-between">
          <FlexBox flexDirection="column" gap="2">
            <Typography fontSkin="body-small-bold">{`Order N.: ${orderId}`}</Typography>
            <Typography fontSkin="body-small">{`Ordered on: ${formatDateWithOrdinal(new Date(orderDate))}`}</Typography>
            <Typography fontSkin="body-small-bold">{`Total paid: ${displayPrice}`}</Typography>
          </FlexBox>
          <FlexBox flexDirection="row" gap="between-icon-and-text">
            {getFormattedItems().map((item) => {
              if (item.type === 'reactNode') {
                return item.element;
              }
              return <FluidImage key={item.itemId} src={item.imageUrl} alt="" style={{ width: '48px', height: '48px', borderRadius: '4px' }} />;
            })}
          </FlexBox>
        </FlexBox>
      </Card>
    </>
  );
};

export default OrderCard;
